import { Injectable } from '@angular/core';
import { GoApplicationRequestFormModel } from '../../../shared/models/go-application-request-form-model';

@Injectable({
    providedIn: 'root',
})
export class GoStorageService {
    private readonly keys = {
        goParametersForm: 'goParametersForm',
    } as const;

    setGoParametersFormCacheData(
        formValue: Partial<GoApplicationRequestFormModel>,
    ): void {
        localStorage.setItem(
            this.keys.goParametersForm,
            JSON.stringify(formValue),
        );
    }

    getGoParametersFormCacheData(): Partial<GoApplicationRequestFormModel> | null {
        const storedValue = localStorage.getItem(this.keys.goParametersForm);
        if (!storedValue) {
            return null;
        }
        try {
            return JSON.parse(
                storedValue,
            ) as Partial<GoApplicationRequestFormModel>;
        } catch (e) {
            console.error('Failed to parse cached Go Parameters form data.', e);
            return null;
        }
    }

    clearCacheData(): void {
        localStorage.removeItem(this.keys.goParametersForm);
    }
}
